import { FormikProps } from 'formik'
import { FormControl, Heading, Input, VStack } from 'native-base'

import { colors } from '../../utils/theme/configureTheme'
import MaskedTextInput from '../Instructions/Form/Input/MaskedTextInput'
import { IssueFormValues } from './types'

interface YourDetailsSectionProps {
  formikProps: FormikProps<IssueFormValues>
}

/** Form section for capturing the consumer's name, email, and phone number for the issue report. */
export default function YourDetailsSection({ formikProps }: YourDetailsSectionProps) {
  const { values, errors, touched, handleChange, handleBlur } = formikProps

  return (
    <VStack space={3} mb={4} backgroundColor={'transparent'}>
      <Heading
        fontSize="18px"
        fontWeight="700"
        fontFamily="Matter SemiBold"
        lineHeight="125%"
        letterSpacing="-2%"
        mb={1}
      >
        Your Details
      </Heading>

      <FormControl isInvalid={!!(errors.name && touched.name)} backgroundColor={'transparent'}>
        <FormControl.Label
          _text={{
            fontWeight: 600,
            fontSize: 13,
            color: colors.brand.softBlack,
          }}
          mt={0}
        >
          Name
        </FormControl.Label>
        <Input
          placeholder="Your Name"
          value={values.name}
          onChangeText={handleChange('name')}
          onBlur={handleBlur('name')}
          backgroundColor={colors.brand.white}
          borderColor={colors.brand.darkGrey}
          borderWidth={2}
          fontSize={16}
          px={2}
          py={'12px'}
          placeholderTextColor={colors.gray[100]}
          color={values.name.length > 0 ? colors.brand.black : colors.gray[100]}
          _focus={{
            placeholderTextColor: colors.gray[100],
            color: values.name.length > 0 ? colors.brand.black : colors.gray[100],
          }}
        />
        {errors.name && touched.name && (
          <FormControl.ErrorMessage backgroundColor={'transparent'}>{errors.name}</FormControl.ErrorMessage>
        )}
      </FormControl>

      <FormControl isInvalid={!!(errors.email && touched.email)} backgroundColor={'transparent'}>
        <FormControl.Label
          _text={{
            fontWeight: 600,
            fontSize: 13,
            color: colors.brand.softBlack,
          }}
          mt={0}
        >
          Email
        </FormControl.Label>
        <Input
          placeholder="John@Doe.com"
          value={values.email}
          onChangeText={handleChange('email')}
          onBlur={handleBlur('email')}
          keyboardType="email-address"
          autoCapitalize="none"
          backgroundColor={colors.brand.white}
          borderColor={colors.brand.darkGrey}
          borderWidth={2}
          fontSize={16}
          px={2}
          py={'12px'}
          placeholderTextColor={colors.gray[100]}
          color={values.email.length > 0 ? colors.brand.black : colors.gray[100]}
          _focus={{
            placeholderTextColor: colors.gray[100],
            color: values.email.length > 0 ? colors.brand.black : colors.gray[100],
          }}
        />
        {errors.email && touched.email && (
          <FormControl.ErrorMessage backgroundColor={'transparent'}>{errors.email}</FormControl.ErrorMessage>
        )}
      </FormControl>

      <FormControl isInvalid={!!(errors.cellPhone && touched.cellPhone)} backgroundColor={colors.brand.warmWhite}>
        <MaskedTextInput
          name="cellPhone"
          label="Cell Phone"
          mask="+1 (999) 999-9999"
          placeholder="(999) 999-9999"
          keyboardType="phone-pad"
          autoComplete="tel"
          textContentType="telephoneNumber"
          borderColor={colors.brand.darkGrey}
          borderWidth={2}
          bg={colors.brand.warmWhite}
          handleChange={handleChange('cellPhone')}
          handleBlur={handleBlur('cellPhone')}
          error={errors.cellPhone}
          value={values.cellPhone}
          touched={touched.cellPhone}
          shouldUseTouch={true}
          errorMessageExternal={null}
          color={values.cellPhone.length > 0 ? colors.brand.black : colors.gray[100]}
          _focus={{
            color: values.cellPhone.length > 0 ? colors.brand.black : colors.gray[100],
          }}
          _disabled={{
            backgroundColor: colors.brand.lightGrey,
            borderColor: colors.brand.darkGrey,
          }}
          _readOnly={{
            backgroundColor: colors.brand.lightGrey,
            borderColor: colors.brand.darkGrey,
          }}
          _input={{
            backgroundColor: colors.brand.white,
          }}
          fontSize={16}
          px={2}
          py={'12px'}
          placeholderTextColor={colors.gray[100]}
        />
      </FormControl>
    </VStack>
  )
}
